import { ISusuarioList, UsuarioList } from '../../../../../types/usuario/UsuarioList';

export interface LicitacaoFormaContratacao {
  id: string; // UUID no formato string
  nome: string;
  ativo: boolean;
}

export const ISlicitacaoFormaContratacao: LicitacaoFormaContratacao = {
  id: '',
  nome: '',
  ativo: false
};

// Interface para SITE_STATUS_PROCESSO
export interface LicitacaoStatusProcesso {
  id: string; // UUID no formato string
  nome: string;
  descricao?: string; // campo opcional, pois no banco pode ser NULL
  ativo: boolean;
}

export const ISlicitacaoStatusProcesso: LicitacaoStatusProcesso = {
  id: '',
  nome: '',
  descricao: '',
  ativo: false
};
export interface Licitacao {
  id?: string;

  processo: string;
  objeto: string;
  pregao: string;
  situacao: LicitacaoStatusProcesso;
  modalidade: LicitacaoFormaContratacao;
  fiscal: string;
  dataHoraCriacao?: Date | string;
  usuario?: UsuarioList;
}
export const ISlicitacao: Licitacao = {
  id: '',

  processo: '',
  objeto: '',
  pregao: '',
  situacao: ISlicitacaoStatusProcesso,
  modalidade: ISlicitacaoFormaContratacao,
  fiscal: '',
  dataHoraCriacao: '',
  usuario: ISusuarioList
};
export interface LicitacaoList {
  id?: string;

  processo: string;
  objeto: string;
  pregao: string;
  situacao: LicitacaoStatusProcesso;
  modalidade: LicitacaoFormaContratacao;
  fiscal: string;
  dataHoraCriacao?: Date | string;
  usuario: UsuarioList;
  temAnexo?: boolean; // Indica se a licitação possui anexos
}
export const ISlicitacaoList: LicitacaoList = {
  id: '',
  processo: '',
  objeto: '',
  pregao: '',
  situacao: ISlicitacaoStatusProcesso,
  modalidade: ISlicitacaoFormaContratacao,
  fiscal: '',
  temAnexo: false,
  dataHoraCriacao: '',
  usuario: ISusuarioList
};

export interface LicitacaoDTO {
  id: string;
  processo: string;
  objeto: string;
  pregao: string;
  idSituacao: string;
  idModalidade: string;
  fiscal: string;
}
export const ISlicitacaoDTO: LicitacaoDTO = {
  id: '',
  processo: '',
  objeto: '',
  pregao: '',
  idModalidade: '',
  idSituacao: '',
  fiscal: ''
};

export interface LicitacaoListPublicResponse {
  results: LicitacaoList[];
  count: number;
  next: string | null;
  previous: string | null;
}
